import { AvvirEvent } from "type_aliases";
import { ProcoreToolsPermissionsResponse } from "avvir";

export type ProcoreToolsPermissionsLoadedEvent = AvvirEvent<typeof PROCORE_TOOLS_PERMISSIONS_LOADED, any>;

const procoreToolsPermissionsLoaded = (procoreToolsPermissionsResponse: ProcoreToolsPermissionsResponse): ProcoreToolsPermissionsLoadedEvent => ({
  type: PROCORE_TOOLS_PERMISSIONS_LOADED,
  payload: procoreToolsPermissionsResponse,
});

export const PROCORE_TOOLS_PERMISSIONS_LOADED = "procore_tools_permissions_loaded";

export default procoreToolsPermissionsLoaded;